import { Skeleton, Space, Typography } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import { H3 } from 'components/new-ui/base/typography/styles';
import { Link } from 'react-router-dom';
import { ManifestDeclarationsResponse } from 'store/manifests/types';

type Props = {
    affectedJobs: ManifestDeclarationsResponse[];
    loading?: boolean;
};

const TransportDetailsDiscrepenciesWarning = ({ affectedJobs, loading }: Props) => {
    if (loading) return <Skeleton active style={{ width: '100%', marginTop: 12, height: 32 }} />;

    if (affectedJobs.length < 1) return null;

    return (
        <div
            style={{
                padding: '12px 16px',
                background: 'var(--orange-1)',
                border: '1px solid var(--orange-3)',
                lineHeight: '22px',
                marginTop: 12,
                marginBottom: 16,
                borderRadius: 6,
            }}
        >
            <Space size={8}>
                <WarningFilled style={{ color: 'var(--orange-6)' }} />
                <H3>Transport details do not match across all declarations</H3>
            </Space>

            <Typography style={{ marginTop: 4 }}>
                One or more declarations have different transport details from the rest. Review and amend where needed.
                Affected jobs:{' '}
                {affectedJobs.map((job, index) => (
                    <span key={job.jobId}>
                        <Link style={{ whiteSpace: 'nowrap' }} to={job.jobId}>
                            {job.jobReferenceId}
                        </Link>
                        {index < affectedJobs.length - 1 && ', '}
                    </span>
                ))}
            </Typography>
        </div>
    );
};

export default TransportDetailsDiscrepenciesWarning;
